export default __webpack_public_path__ + "static/media/pakrap-1.d94a7783.mp3";